import {commitMutation, graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';

// The whole set is posted together, and the server's recomputed bands come back on the company — one
// edit rewrites a neighbouring band's start, so there is no correct optimistic update to apply.
const mutation = graphql`
	mutation updateOpportunityStageBandsMutationModernMutation($input: UpdateOpportunityStageBandsInput!) {
		updateOpportunityStageBands(input: $input) {
			company {
				...opportunityStageBandsCompany_company
			}
		}
	}
`;

function getConfigs() {
	return [];
}

function commit(environment, input, onSuccess, onError) {
	const variables = {...input};

	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...variables}},
		configs: getConfigs(),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
